// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTextWrap as RawLucideTextWrap } from "lucide-react";
export const LucideTextWrap = /* @__PURE__ */ createIcon(RawLucideTextWrap, "LucideTextWrap", 2);
